import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type DevAgent = {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  category: string;
  system_prompt: string;
  default_model: string;
  input_label: string;
  input_placeholder: string;
  is_seed: boolean;
};

export function useDevAgents() {
  return useQuery({
    queryKey: ["dev_agents"],
    queryFn: async (): Promise<DevAgent[]> => {
      const { data, error } = await supabase
        .from("dev_agents")
        .select("id,slug,name,description,icon,category,system_prompt,default_model,input_label,input_placeholder,is_seed")
        .order("name");
      if (error) throw error;
      return (data ?? []) as DevAgent[];
    },
  });
}

export function useDevAgent(slug: string | undefined) {
  return useQuery({
    enabled: !!slug,
    queryKey: ["dev_agent", slug],
    queryFn: async (): Promise<DevAgent | null> => {
      const { data, error } = await supabase
        .from("dev_agents")
        .select("id,slug,name,description,icon,category,system_prompt,default_model,input_label,input_placeholder,is_seed")
        .eq("slug", slug!)
        .maybeSingle();
      if (error) throw error;
      return (data as DevAgent) ?? null;
    },
  });
}